// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"error-triangle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0003 3L22.2194 20.7H1.78125L12.0003 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0003 3L22.2194 20.7H1.78125L12.0003 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 10.5V14M12 17.5H12.0039V17.5039H12V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ErrorTriangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'error-triangle',
    ref,
    icon: element,
  },
));

ErrorTriangleIcon.displayName = 'ErrorTriangleIcon';

export default ErrorTriangleIcon;
